import React from "react";

type Props = {
  color?: React.CSSProperties["color"];
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
};

const Hamburger = ({ width = 22, height = 22, color = "#fff" }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.2 5H10.2C10.5183 5 10.8235 5.12643 11.0485 5.35147C11.2736 5.57652 11.4 5.88174 11.4 6.2C11.4 6.51826 11.2736 6.82348 11.0485 7.04853C10.8235 7.27357 10.5183 7.4 10.2 7.4H4.2C3.88174 7.4 3.57652 7.27357 3.35147 7.04853C3.12643 6.82348 3 6.51826 3 6.2C3 5.88174 3.12643 5.57652 3.35147 5.35147C3.57652 5.12643 3.88174 5 4.2 5ZM12.6 14.6H18.6C18.9183 14.6 19.2235 14.7264 19.4485 14.9515C19.6736 15.1765 19.8 15.4817 19.8 15.8C19.8 16.1183 19.6736 16.4235 19.4485 16.6485C19.2235 16.8736 18.9183 17 18.6 17H12.6C12.2817 17 11.9765 16.8736 11.7515 16.6485C11.5264 16.4235 11.4 16.1183 11.4 15.8C11.4 15.4817 11.5264 15.1765 11.7515 14.9515C11.9765 14.7264 12.2817 14.6 12.6 14.6ZM4.2 9.8H18.6C18.9183 9.8 19.2235 9.92643 19.4485 10.1515C19.6736 10.3765 19.8 10.6817 19.8 11C19.8 11.3183 19.6736 11.6235 19.4485 11.8485C19.2235 12.0736 18.9183 12.2 18.6 12.2H4.2C3.88174 12.2 3.57652 12.0736 3.35147 11.8485C3.12643 11.6235 3 11.3183 3 11C3 10.6817 3.12643 10.3765 3.35147 10.1515C3.57652 9.92643 3.88174 9.8 4.2 9.8Z"
        fill={color}
      />
    </svg>
  );
};

export default Hamburger;
